import React, {useCallback, useState} from "react";
import PropTypes from "prop-types";
import forwardRef from "../../../hoc/ForwardRef";
import {ErrorHelperText, Input, TextfieldDiv, TextfieldLabel} from "./widgets/Styled";
import {validateField} from "../../../utils/validation";

const TextField = (props) => {
    const {
        isFocused = false,
        placeholder,
        onBlur,
        id,
        initialValue,
        type,
        onChange,
        isFilled = false,
        isDisabled = false,
        isTouched = false,
        error,
        ariaLabel,
        ariaDescription,
        textFieldStyle,
        commonFieldStyle,
        InnerTextFieldComponent,
        scoreWidth = false,
        inputRFF = {},
        forwardRef,
        ...rest
    } = props;
    const isError = error && isTouched;
    const isRFF = !!inputRFF?.name;
    const [text, setText] = useState(isRFF ? undefined : initialValue);
    const [focus, setFocus] = useState(isRFF ? undefined : isFocused);
    const [filled, setFilled] = useState(isRFF ? undefined : isFilled);
    const textRFF = isRFF ? initialValue : undefined;
    const focusRFF = isRFF ? isFocused : undefined;
    const filledRFF = isRFF ? isFilled : undefined;

    const outsideClick = useCallback(() => {
        //  console.log(text.length);
        if (onBlur) onBlur();

        if (text === "") {
            setFilled(false);
        }
        //setFocus(false);
        if (text.length > 0) {
            setFilled(true);
        }
    }, [onBlur, text]);

    return (
        <TextfieldDiv
            isError={isError}
            textFieldStyle={textFieldStyle}
            commonFieldStyle={commonFieldStyle}
        >
            <TextfieldLabel
                value={text ?? textRFF}
                isFilled={filled ?? filledRFF}
                isFocused={focus ?? focusRFF}
                disabled={isDisabled}
                isError={isError}
                htmlFor={inputRFF?.name ?? ""}
            >
                {placeholder}
            </TextfieldLabel>
            <Input
                id={isRFF ? inputRFF?.name : id}
                type={type}
                ref={forwardRef}
                {...(!isRFF
                    ? {
                          onFocus: () => setFocus(true),
                          onBlur: () => outsideClick(),
                          onChange: (value) => {
                              setText(value.target.value);
                              if (onChange) onChange(value);
                          },
                      }
                    : {})}
                autoFocus={focus ?? focusRFF}
                isFocused={focus ?? focusRFF}
                isFilled={filled ?? filledRFF}
                disabled={isDisabled ? "disabled" : ""}
                isError={isError}
                aria-labelledby={ariaLabel}
                aria-describedby={ariaDescription}
                textFieldStyle={textFieldStyle}
                {...rest}
                {...inputRFF}
                {...(isRFF ? {value: inputRFF?.value ?? ""} : text)}
            />

            {validateField(InnerTextFieldComponent) &&
                inputRFF.value.length > 0 &&
                InnerTextFieldComponent}
            {isError && (focus ?? focusRFF) && (
                <ErrorHelperText scoreWidth={scoreWidth}>{error}</ErrorHelperText>
            )}
        </TextfieldDiv>
    );
};

TextField.propTypes = {
    isFocused: PropTypes.bool,
    isFilled: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isTouched: PropTypes.bool,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    forwardRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            current: PropTypes.instanceOf(
                typeof Element === "undefined" ? function () {} : Element,
            ),
        }),
    ]),
    initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.string,
    height: PropTypes.number,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    error: PropTypes.string,
    ariaLabel: PropTypes.string,
    ariaDescription: PropTypes.string,
    textFieldStyle: PropTypes.object,
    commonFieldStyle: PropTypes.object,
    input: PropTypes.object,
    inputRFF: PropTypes.object,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    autoComplete: PropTypes.string,
    tabIndex: PropTypes.string,
    InnerTextFieldComponent: PropTypes.any,
    scoreWidth: PropTypes.bool,
};
TextField.defaultProps = {
    initialValue: "",
    error: "",
    //InnerTextFieldComponent: null,
};

export default forwardRef(TextField);
